import { API_GATEWAY_URL } from '../constants/config';
import { withStandardHandlers } from './utils';
export const POTREE_FILES_API_URL = `${API_GATEWAY_URL}/potree-files`;
export const DOWN_SAMPLED_FILES_API_URL = `${API_GATEWAY_URL}/down-sampled-files`;
/**
 * Get signed URL for uploading a file
 * @param accessToken - The access token for authentication.
 * @param fileName - The file name.
 * @param contentType - The content type.
 */
export const getSignedUrlForUploadFile = (accessToken, fileName, contentType) => {
    const fn = () => fetch(`${API_GATEWAY_URL}/origin-files`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            responseType: 'json',
            'X-Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
            file_name: fileName,
            content_type: contentType,
        }),
    });
    return withStandardHandlers(fn, 'errors.file.getSignedUrl')();
};
/**
 * Get signed URL for uploading a mesh file
 * @param accessToken - The access token for authentication.
 * @param projectId - The project ID.
 * @param inspectionAreaId - The inspection area ID.
 * @param fileName - The file name.
 */
export const getSignedUrlForUploadMeshFile = (accessToken, projectId, inspectionAreaId, fileName) => {
    const fn = () => fetch(`${API_GATEWAY_URL}/projects/${projectId}/inspection-areas/${inspectionAreaId}/mesh-bundle-files`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            responseType: 'json',
            'X-Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
            file_name: fileName,
        }),
    });
    return withStandardHandlers(fn, 'errors.file.getSignedUrl')();
};
/**
 * Get signed URL for Potree files.
 *
 * @param access_token Auth0 Access token
 * @param project_id Project ID of the inspection area
 * @param inspection_area_id Inspection Area ID of the potree files
 * @returns
 */
export const getSignedUrlForPotreeFiles = (accessToken, projectId, inspectionAreaId, blueprintId) => {
    const params = new URLSearchParams({
        project_id: projectId,
        inspection_area_id: inspectionAreaId,
    });
    if (blueprintId) {
        params.append('blueprint_id', blueprintId);
    }
    const fn = () => fetch(`${POTREE_FILES_API_URL}?${params.toString()}`, {
        method: 'GET',
        headers: {
            'X-Authorization': `Bearer ${accessToken}`,
        },
    });
    return withStandardHandlers(fn, 'errors.file.getSignedUrl')();
};
/**
 * Get a signed URL for downloading a down-sampled point cloud file.
 * @param accessToken - The access token for authentication.
 * @param projectId - The project ID.
 * @param inspectionAreaId - The inspection area ID.
 * @returns A signed URL string.
 */
export const getSignedUrlForGetDownSampledFile = (accessToken, projectId, inspectionAreaId) => {
    const params = new URLSearchParams({
        project_id: projectId,
        inspection_area_id: inspectionAreaId,
    });
    const fn = () => fetch(`${DOWN_SAMPLED_FILES_API_URL}?${params.toString()}`, {
        method: 'GET',
        headers: {
            'X-Authorization': `Bearer ${accessToken}`,
        },
    });
    return withStandardHandlers(fn, 'errors.file.getSignedUrl')().then((response) => response.url);
};
/**
 * Upload a file to a signed URL (e.g., AWS S3)
 * @param url - The signed URL to upload to.
 * @param contentType - The content type of the file.
 * @param file - The file to upload.
 */
export const uploadFile = async (url, contentType, file) => {
    const response = await fetch(url, {
        method: 'PUT',
        headers: {
            'Content-Type': contentType,
        },
        body: file,
    });
    if (!response.ok) {
        throw new Error(`File upload failed with status ${response.status}`);
    }
};
/**
 * Download a file as blob
 * @param url - The URL to download from.
 */
export const downloadFile = async (url) => {
    const response = await fetch(url, {
        method: 'GET',
    });
    if (!response.ok) {
        throw new Error(`File download failed with status ${response.status}`);
    }
    const blob = await response.blob();
    return {
        blob,
        type: blob.type,
    };
};
